module.exports = __webpack_public_path__ + "img/speed3d.c92c97fd.jpg";